module.exports = __webpack_public_path__ + "static/media/error.6db55f0d.png";